import { Component, forwardRef, Inject } from '@angular/core';
import { NgbActiveModal }                from '@ng-bootstrap/ng-bootstrap';
import { NgForm }                        from '@angular/forms';

import { AmsRewardsService } from './ams-rewards.service';
import { MessagesService }   from '../messages/messages.service';
import { TranslateService }  from '@ngx-translate/core';

@Component({
  selector   : 'ams-rewards-csv',
  template: require('./ams-rewards.csv.component.html')
})
export class AmsRewardsCsvComponent {
  endDate  : string;
  startDate: string;

  constructor (
    public  activeModal      : NgbActiveModal,
    @Inject(forwardRef(() => AmsRewardsService))
    private amsRewardsService: AmsRewardsService,
    private messagesService  : MessagesService,
    private translateService : TranslateService
  ) {}

  download ( form : NgForm ) : void {
    window.open(this.amsRewardsService.getDownloadUrl(this.startDate, this.endDate), '_blank');

    this.messagesService.show(this.translateService.instant('JS_SPACE.AMS_REWARDS.DOWNLOADED_UPLOAD_TO_AMS'), 'success');

    this.activeModal.close();
  }
}
